import { render, staticRenderFns } from "./EventRecord.vue?vue&type=template&id=6635997f&scoped=true&"
import script from "./EventRecord.vue?vue&type=script&lang=js&"
export * from "./EventRecord.vue?vue&type=script&lang=js&"
import style0 from "./EventRecord.vue?vue&type=style&index=0&id=6635997f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6635997f",
  null
  
)

component.options.__file = "EventRecord.vue"
export default component.exports